import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, TextInput, Button, Form, Image, Label } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { TimeoutLink } from 'ui/components/shared';
import { useUser, useToasts, useLayout } from 'hooks';
import { CloseButton } from 'ui/components/shared';

export const TFASMSVerify = () => {
  const [token, setToken] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { user, challenges, saveChallenges, signOut, redirectToDashboard } = useUser();
  const { errorToast } = useToasts();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/challenges/sms/verify', { token });
      if (response.status === 200) {
        if (response.data?.success) {
          saveChallenges({ valid: true });
          redirectToDashboard();
          return;
        } else {
          errorToast('Token code is wrong!');
        }
      }
    } catch (error) {
      errorToast({ error, default: 'Error: 2FA SMS verify.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout show={challenges.required} justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Two-step verification</Title>
        <Title type="h3" variant="grey" mb="m">
          Thanks for keeping your account secure.
          <br />
          Check your token device: (xxx)-xxx-xx{(user.phone || '').slice(-2)}
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Label htmlFor="token" mb="xs">
              Your token code
            </Label>
            <TextInput
              id="token"
              name="token"
              type="token"
              length={6}
              placeholder="6-digit code"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            Log in Securely
          </Button>
          <TimeoutLink timeout={30} my="m" to="/2fa/sms">
            Resend SMS
          </TimeoutLink>
        </Form>
      </Container>
      <CloseButton title="Logout" onClick={signOut} />
    </AuthLayout>
  );
};
